"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { dark } from "@clerk/themes";
import type { Theme } from "@clerk/types";
import { useTheme } from "next-themes";
import type { ComponentProps } from "react";

export const AuthProvider = (
  properties: ComponentProps<typeof ClerkProvider>
) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const baseTheme = isDark ? dark : undefined;
  const variables: Theme["variables"] = {
    fontFamily: "var(--font-geist-sans), sans-serif",
    fontFamilyButtons: "var(--font-geist-sans), sans-serif",
    borderRadius: "0.5rem",
    colorPrimary: "hsl(var(--primary))",
    colorPrimaryForeground: "hsl(var(--primary-foreground))",
    colorDanger: "hsl(var(--destructive))",
    colorBackground: "hsl(var(--card))",
    colorForeground: "hsl(var(--foreground))",
    colorInput: "hsl(var(--input))",
    colorBorder: "hsl(var(--border))",
    colorRing: "hsl(var(--ring))",
  };

  const elements: Theme["elements"] = {
    rootBox: "w-full",
    card: "w-full overflow-visible",
    cardBox:
      "w-full max-w-none overflow-visible rounded-lg border border-border/70 bg-card/95 shadow-2xl shadow-primary/10 backdrop-blur",
    footerActionLink: "font-medium text-primary hover:text-primary/80",
    formButtonPrimary:
      "h-11 rounded-lg bg-primary font-medium text-primary-foreground shadow-sm shadow-primary/20 transition-colors hover:bg-primary/90",
    formFieldInput:
      "h-11 rounded-lg border-border bg-background text-foreground shadow-sm",
    organizationSwitcherTrigger:
      "w-full justify-start rounded-lg border border-border/70 bg-background px-3 py-2 shadow-sm transition-colors hover:bg-accent/30",
  };

  return (
    <ClerkProvider
      {...properties}
      appearance={{ baseTheme, variables, elements }}
    />
  );
};
